import CloseIcon from '@mui/icons-material/Close'
import { useTheme, Box, Dialog, DialogTitle, DialogContent, Typography } from '@mui/material'
import PropTypes from 'prop-types'

import { IconButton } from '../buttons/IconButton'

/**
 * @description Renders a visualization modal component.
 *
 * @author Maria Eduarda Franke
 * @param {boolean} props.open - Determines whether the modal is open or not.
 * @param {function} props.onClose - The function to be called when the modal is closed.
 * @param {string} props.title - The title of the modal.
 * @param {string} props.description - The description of the modal.
 * @param {ReactNode} props.children - The content of the modal.
 * @returns {ReactNode} The rendered form modal component.
 */
const VisualizationModal = ({ open, onClose, title, children, ...props }) => {

    const theme = useTheme()

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth='md'
            {...props}
        >
            <DialogTitle>
                <Box display='flex' flexDirection='row' justifyContent='space-between' alignItems='center'>
                    <Typography variant='h6'>{title}</Typography>
                    <IconButton color={theme.palette.text.secondary} onClick={onClose}>
                        <CloseIcon />
                    </IconButton>
                </Box>
            </DialogTitle>

            <DialogContent>
                    {children}
            </DialogContent>
        </Dialog>
    )
}

VisualizationModal.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    children: PropTypes.node
}

export default VisualizationModal
